const baseTitle = 'CaRT';

const updatePageTitle = (page, extraInfo = '') => {
  document.title = `${baseTitle} | ${page} ${extraInfo}`;
};

export default {
  updatePageTitle,
};
